module.exports = __webpack_public_path__ + "static/team-20-1572dbb9e2019f8c2545a764d876f42e.jpg";